import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DisplayIdentifier} from 'src/smoothr-web-app-core/enums/DisplayIdentifier';
import {OrderType} from 'src/smoothr-web-app-core/enums/OrderType';
import {PreorderType} from 'src/smoothr-web-app-core/enums/PreorderType';
import Article from 'src/smoothr-web-app-core/models/Article';
import ArticleOption from 'src/smoothr-web-app-core/models/ArticleOption';
import OptionGroup from 'src/smoothr-web-app-core/models/OptionGroup';
import {getPrice, numberToCurrency} from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-article-option-group-toggle',
	templateUrl: './article-option-group-toggle.component.html',
	styleUrls: ['./article-option-group-toggle.component.scss']
})
export class ArticleOptionGroupToggleComponent {
	@Input() optionGroup: OptionGroup;
	@Input() selected: ArticleOption[];
	@Input() article: Article;
	@Output() selection = new EventEmitter<ArticleOption>();
	@Output() openInfo = new EventEmitter<Article>();
	@Input() preorderType: PreorderType;
	@Input() currency: string;
	di = DisplayIdentifier;
	numberToCurrency = numberToCurrency;
	constructor() {}
	price(option: Article): number {
		let price = +getPrice(option, OrderType.PREORDER, this.preorderType);
		if (this.fullPrice()) {
			price += +getPrice(this.article, OrderType.PREORDER, this.preorderType);
		}
		return price;
	}
	fullPrice(): boolean {
		return (
			this.optionGroup.displayIdentifiers &&
			this.optionGroup.displayIdentifiers.findIndex(di => di === DisplayIdentifier.fullPrice) >= 0
		);
	}

	isSelected(article: Article) {
		return (
			this.selected.findIndex(
				selected => selected.group === this.optionGroup._id && selected.article._id === article._id
			) >= 0
		);
	}

	select(article: Article) {
		const option = new ArticleOption();
		option.article = article;
		option.group = this.optionGroup._id;
		option.quantity = 1;
		this.selection.emit(option);
	}
}
